module.exports = __webpack_public_path__ + "assets/img/withdraw-support-tech.e4772f64.svg";